import { render, staticRenderFns } from "./ChainAdministration.vue?vue&type=template&id=41b8028c&"
import script from "./ChainAdministration.vue?vue&type=script&lang=js&"
export * from "./ChainAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports